// El motor de páginas del pie (`LoadedScopeFooter`): TanStack Table sobre las filas YA filtradas y
// ordenadas. Solo corta lo cargado en páginas; las columnas las pinta el `DataTable`.
import {
    getCoreRowModel,
    getPaginationRowModel,
    useReactTable,
    type ColumnDef,
    type Table,
} from '@tanstack/react-table';

export const LOADED_PAGE_SIZE = 30;

const NO_COLUMNS: ColumnDef<never>[] = [];

export function useLoadedPaginationTable<T>(
    rows: T[],
    pageSize: number = LOADED_PAGE_SIZE,
    {
        autoResetPageIndex = true,
    }: {
        /** `false` cuando llegan páginas solas: quien llama reinicia la página al cambiar filtros. */
        autoResetPageIndex?: boolean;
    } = {},
): Table<T> {
    return useReactTable<T>({
        data: rows,
        columns: NO_COLUMNS as ColumnDef<T>[],
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: { pagination: { pageSize } },
        autoResetPageIndex,
    });
}
